/**
 * Routes reached from the ACCOUNT MENU rather than from the sidebar.
 *
 * ── WHY THIS CONSTANT EXISTS AT ALL ───────────────────────────────────────
 *
 * `nav.test.ts` asserts two things that are both worth keeping: every nav item
 * has a route, and every route is reachable from the nav. The second is what
 * catches dead code — a screen somebody built, wired a route for, and never
 * linked, which is exactly the shape of the 984-line player-admin module that
 * had no door.
 *
 * `/account` is genuinely not a sidebar module. It is the signed-in person's own
 * credentials, it has no permission key, every role has it, and the product IA
 * names twenty modules — a count three assertions and the documented claim both
 * depend on. Adding it to `NAV_GROUPS` would make the console twenty-one modules
 * to make one test pass.
 *
 * So the escape is NAMED and SHARED rather than written as an exception inside
 * the test. The shell reads this list to build the menu and the tests read it to
 * excuse the route, so a screen can only be excused from the orphan check by
 * being genuinely reachable from the menu — and a path added here that the shell
 * does not link, or that has no route, is a failure rather than a silence.
 */
export const ACCOUNT_MENU_ROUTES = [
  {
    path: '/account',
    label: 'Your account',
    /* The DESCRIPTION, not part of the name — a menu item called "Your account
       Password, authenticator and recovery codes." is not a thing anybody can
       ask for by voice. */
    note: 'Password, authenticator and recovery codes.',
    icon: 'shield-check',
  },
] as const;

export type AccountMenuRoute = (typeof ACCOUNT_MENU_ROUTES)[number];
